// src/pages/Idees.js
import { useState, useMemo } from 'react';
import { drawCards } from '../data/cardsApi';
import { Card, IntensityPicker } from '../components/Card';
import { PageShell, PageTitle, Divider, SectionLabel, SectionHead } from '../components/PageShell';

const SECTIONS = [
  { type: 'punition', context: 'maison',   icon: '😈', title: 'Punitions',              count: 4 },
  { type: 'punition', context: 'distance', icon: '💌', title: 'Punitions à distance',   count: 4 },
  { type: 'date',     context: 'general',  icon: '🌙', title: 'Idées de dates',         count: 4 },
  { type: 'conseil',  context: 'general',  icon: '💡', title: 'Conseils',               count: 3 },
];

export function Idees({ favs, onFav }) {
  const [intensity, setIntensity] = useState(2);

  // Recalcule les cartes à chaque changement d'intensité
  const sections = useMemo(() =>
    SECTIONS.map(s => ({
      ...s,
      cards: drawCards({ type: s.type, context: s.context, maxIntensity: intensity }, s.count),
    })),
  [intensity]);

  return (
    <PageShell>
      <PageTitle>Idées de bêtises</PageTitle>
      <SectionLabel>Intensité</SectionLabel>
      <IntensityPicker value={intensity} onChange={setIntensity}/>
      <Divider style={{ margin: '24px 0 32px' }}/>

      {sections.map(s => (
        <div key={`${s.type}-${s.context}`} style={{ marginBottom: 36 }}>
          <SectionHead icon={s.icon} title={s.title}/>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {s.cards.map(card => (
              <Card key={card.id} card={card}
                isFav={favs.some(f => f.id === card.id)} onFav={onFav} compact/>
            ))}
          </div>
        </div>
      ))}
    </PageShell>
  );
}
